import React from 'react';
import { XCircle } from 'lucide-react';

const PaymentCancelled = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* Icon */}
        <div className="w-16 h-16 mx-auto mb-6 bg-yellow-100 rounded-full flex items-center justify-center">
          <XCircle className="w-8 h-8 text-yellow-600" />
        </div>

        {/* Message */}
        <h1 className="text-xl font-semibold text-gray-900 mb-2">
          Payment Cancelled
        </h1>
        <p className="text-sm text-gray-600">
          Your payment was cancelled. You were not charged.
        </p>
      </div>
    </div>
  );
};

export default PaymentCancelled;
